import firebase from 'firebase/app';
import 'firebase/firestore';


const firebaseConfig = {
    apiKey: "AIzaSyDrZ7Ws3ka_OW4y_PJOviTd1GmfgmhySvY",
    authDomain: "projman-47bf9.firebaseapp.com",
    databaseURL: "https://projman-47bf9.firebaseio.com",
    projectId: "projman-47bf9",
    storageBucket: "projman-47bf9.appspot.com",
    messagingSenderId: "280623831791",
    appId: "1:280623831791:web:a8d1d89fd280dc3e69591a"
};


// Initialize Firebase
firebase.initializeApp(firebaseConfig);


// firebase utils
const db = firebase.firestore()
// const auth = firebase.auth()
// const currentUser = auth.currentUser


// firebase collections
const teamCollection = db.collection('team')
const demandsCollection = db.collection('/demands')
const planningCollection = db.collection('planning')


export default{
    db,
    teamCollection,
    demandsCollection,
    planningCollection
}